import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import GraphicsSearchPageContent from './Content';
import type { GraphicsSearchPageProps } from './interfaces';
import './styles.scss';

const queryClient = new QueryClient();

const GraphicsSearchPage = ({
  currentPage,
  env,
  initialCurrentUser,
  initialSearchQuery,
  isGdprRequired,
  isWebview,
  pageCount,
  paywallData,
  searchResults,
}: GraphicsSearchPageProps) => {
  const { Track } = useEventTracking({
    page: Page.GraphicsSearch,
  });

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <GraphicsSearchPageContent
            currentPage={currentPage}
            env={env}
            initialCurrentUser={initialCurrentUser}
            initialSearchQuery={initialSearchQuery}
            isGdprRequired={isGdprRequired}
            isWebview={isWebview}
            pageCount={pageCount}
            paywallData={paywallData}
            searchResults={searchResults}
          />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default GraphicsSearchPage;
